export const LOGIN = 'LOGIN'
export const LOGIN_LOADING = 'LOGIN_LOADING'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_ERROR = 'LOGIN_ERROR'

export const LOGOUT = 'LOGOUT'
export const LOGOUT_LOADING = 'LOGOUT_LOADING'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_ERROR = 'LOGOUT_ERROR'

export const REFRESH_TOKEN = 'REFRESH_TOKEN'
export const REFRESH_TOKEN_LOADING = 'REFRESH_TOKEN_LOADING'
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS'
export const REFRESH_TOKEN_ERROR = 'REFRESH_TOKEN_ERROR'

export const FETCH_GEO_IP = 'FETCH_GEO_IP'
export const FETCH_GEO_IP_LOADING = 'FETCH_GEO_IP_LOADING'
export const FETCH_GEO_IP_SUCCESS = 'FETCH_GEO_IP_SUCCESS'
export const FETCH_GEO_IP_ERROR = 'FETCH_GEO_IP_ERROR'

export const SIGNUP = 'SIGNUP'
export const SIGNUP_LOADING = 'SIGNUP_LOADING'
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS'
export const SIGNUP_ERROR = 'SIGNUP_ERROR'

export const SIGNUP_WITH_FACEBOOK = 'SIGNUP_WITH_FACEBOOK'
export const SIGNUP_WITH_FACEBOOK_LOADING = 'SIGNUP_WITH_FACEBOOK_LOADING'
export const SIGNUP_WITH_FACEBOOK_SUCCESS = 'SIGNUP_WITH_FACEBOOK_SUCCESS'
export const SIGNUP_WITH_FACEBOOK_ERROR = 'SIGNUP_WITH_FACEBOOK_ERROR'

export const INIT_SIGNUP_WITH_FACEBOOK = 'INIT_SIGNUP_WITH_FACEBOOK'
export const INIT_SIGNUP_WITH_FACEBOOK_LOADING = 'INIT_SIGNUP_WITH_FACEBOOK_LOADING'
export const INIT_SIGNUP_WITH_FACEBOOK_SUCCESS = 'INIT_SIGNUP_WITH_FACEBOOK_SUCCESS'
export const INIT_SIGNUP_WITH_FACEBOOK_ERROR = 'INIT_SIGNUP_WITH_FACEBOOK_ERROR'

export const CONNECT_FACEBOOK = 'CONNECT_FACEBOOK'
export const CONNECT_FACEBOOK_LOADING = 'CONNECT_FACEBOOK_LOADING'
export const CONNECT_FACEBOOK_SUCCESS = 'CONNECT_FACEBOOK_SUCCESS'
export const CONNECT_FACEBOOK_ERROR = 'CONNECT_FACEBOOK_ERROR'

export const LOGIN_WITH_FACEBOOK = 'LOGIN_WITH_FACEBOOK'
export const LOGIN_WITH_FACEBOOK_LOADING = 'LOGIN_WITH_FACEBOOK_LOADING'
export const LOGIN_WITH_FACEBOOK_SUCCESS = 'LOGIN_WITH_FACEBOOK_SUCCESS'
export const LOGIN_WITH_FACEBOOK_ERROR = 'LOGIN_WITH_FACEBOOK_ERROR'

export const GET_FACEBOOK_STATUS = 'GET_FACEBOOK_STATUS'
export const GET_FACEBOOK_STATUS_LOADING = 'GET_FACEBOOK_STATUS_LOADING'
export const GET_FACEBOOK_STATUS_SUCCESS = 'GET_FACEBOOK_STATUS_SUCCESS'
export const GET_FACEBOOK_STATUS_ERROR = 'GET_FACEBOOK_STATUS_ERROR'

export const RELOAD_USER = 'RELOAD_USER'
export const RELOAD_USER_LOADING = 'RELOAD_USER_LOADING'
export const RELOAD_USER_SUCCESS = 'RELOAD_USER_SUCCESS'
export const RELOAD_USER_ERROR = 'RELOAD_USER_ERROR'

export const RELOAD_AUTH = 'RELOAD_AUTH'
export const RELOAD_AUTH_LOADING = 'RELOAD_AUTH_LOADING'
export const RELOAD_AUTH_SUCCESS = 'RELOAD_AUTH_SUCCESS'
export const RELOAD_AUTH_ERROR = 'RELOAD_AUTH_ERROR'

export const LOGIN_OR_SIGNUP_WITH_FACEBOOK = 'LOGIN_OR_SIGNUP_WITH_FACEBOOK'
export const LOGIN_OR_SIGNUP_WITH_FACEBOOK_LOADING = 'LOGIN_OR_SIGNUP_WITH_FACEBOOK_LOADING'
export const LOGIN_OR_SIGNUP_WITH_FACEBOOK_SUCCESS = 'LOGIN_OR_SIGNUP_WITH_FACEBOOK_SUCCESS'
export const LOGIN_OR_SIGNUP_WITH_FACEBOOK_ERROR = 'LOGIN_OR_SIGNUP_WITH_FACEBOOK_ERROR'

export const UPDATE_API_CONFIGS = 'UPDATE_API_CONFIGS'

export const INIT_ONBOARDING = 'INIT_ONBOARDING'
export const INIT_FACEBOOK_ONBOARDING = 'INIT_FACEBOOK_ONBOARDING'

export const REQUEST_PASSWORD_RESET = 'REQUEST_PASSWORD_RESET'
export const REQUEST_PASSWORD_RESET_LOADING = 'REQUEST_PASSWORD_RESET_LOADING'
export const REQUEST_PASSWORD_RESET_SUCCESS = 'REQUEST_PASSWORD_RESET_SUCCESS'
export const REQUEST_PASSWORD_RESET_ERROR = 'REQUEST_PASSWORD_RESET_ERROR'

export const CLEAR_LEGACY = 'CLEAR_LEGACY'
export const CLEAR_LEGACY_LOADING = 'CLEAR_LEGACY_LOADING'
export const CLEAR_LEGACY_SUCCESS = 'CLEAR_LEGACY_SUCCESS'
export const CLEAR_LEGACY_ERROR = 'CLEAR_LEGACY_ERROR'

export const GET_FB_PROFILE = 'GET_FB_PROFILE'
export const GET_FB_PROFILE_LOADING = 'GET_FB_PROFILE_LOADING'
export const GET_FB_PROFILE_SUCCESS = 'GET_FB_PROFILE_SUCCESS'
export const GET_FB_PROFILE_ERROR = 'GET_FB_PROFILE_ERROR'

export const REFRESH_AND_RELOAD = 'REFRESH_AND_RELOAD'
export const REFRESH_AND_RELOAD_LOADING = 'REFRESH_AND_RELOAD_LOADING'
export const REFRESH_AND_RELOAD_SUCCESS = 'REFRESH_AND_RELOAD_SUCCESS'
export const REFRESH_AND_RELOAD_ERROR = 'REFRESH_AND_RELOAD_ERROR'

export const FB_ONBOARDING = 'fb'
export const UACF_ONBOARDING = 'uacf'
export const UACF_FB_ONBOARDING = 'uacf-fb'

export const STASH_EMAIL_FOR_ONBOARDING = 'STASH_EMAIL_FOR_ONBOARDING'

export const STAGE_USER = 'STAGE_USER'
export const CANCEL_ONBOARDING_PROMPT = 'CANCEL_ONBOARDING_PROMPT'

export const FIND_USER_BY_EMAIL = 'FIND_USER_BY_EMAIL'
export const FIND_USER_BY_EMAIL_LOADING = 'FIND_USER_BY_EMAIL_LOADING'
export const FIND_USER_BY_EMAIL_SUCCESS = 'FIND_USER_BY_EMAIL_SUCCESS'
export const FIND_USER_BY_EMAIL_ERROR = 'FIND_USER_BY_EMAIL_ERROR'

// WECHAT
export const LOGIN_WITH_WECHAT = 'LOGIN_WITH_WECHAT'
export const LOGIN_WITH_WECHAT_LOADING = 'LOGIN_WITH_WECHAT_LOADING'
export const LOGIN_WITH_WECHAT_SUCCESS = 'LOGIN_WITH_WECHAT_SUCCESS'
export const LOGIN_WITH_WECHAT_ERROR = 'LOGIN_WITH_WECHAT_ERROR'

export const SIGNUP_WITH_WECHAT = 'SIGNUP_WITH_WECHAT'
export const SIGNUP_WITH_WECHAT_LOADING = 'SIGNUP_WITH_WECHAT_LOADING'
export const SIGNUP_WITH_WECHAT_SUCCESS = 'SIGNUP_WITH_WECHAT_SUCCESS'
export const SIGNUP_WITH_WECHAT_ERROR = 'SIGNUP_WITH_WECHAT_ERROR'

export const SET_WECHAT_AUTH_STATE = 'SET_WECHAT_AUTH_STATE'
